import { GODIA_LOYALTY } from "@constants";
import { t } from "i18next";
import PropTypes from "prop-types";
import { useSnapshot } from "valtio";

import React from "react";
import { shallowEqual, useSelector } from "react-redux";

import { kioskStore as store } from "@pages/Kiosk/store";

export default function SummaryHeader() {
    const { summaryHeaderBravoText, summaryHeaderLoyaltyPointText } =
        useSelector((state) => state.settingSlice.summary, shallowEqual);
    const { orderFidelity, totalPrice } = useSelector(
        (state) => state.orderSlice.order,
        shallowEqual
    );
    const {
        isUserAuthenticated,
        customerLanguage,
        user,
        project: { fidelityType },
    } = useSnapshot(store);

    const godiaOrderFidelity = Math.round(totalPrice * user.pointRatio);

    const totalFidelity =
        fidelityType === GODIA_LOYALTY &&
        user.isCumulativeLoyaltyPointsOnTotalOrder
            ? godiaOrderFidelity
            : orderFidelity;
    if (!isUserAuthenticated) return null;
    return (
        <>
            <hr className="separation-line" />
            <div className="header-text pl-4">
                <span
                    style={{
                        fontWeight: "bold",
                        fontSize: "var(--font-size-title)",
                        lineHeight: "54px",
                    }}
                >
                    {
                        summaryHeaderBravoText.languages[customerLanguage.name]
                            .content
                    }
                </span>
                <br />
                <span
                    style={{
                        fontWeight: 400,
                        fontSize: "var(--font-size-subtitle)",
                        lineHeight: "40px",
                    }}
                >
                    {`${
                        summaryHeaderLoyaltyPointText.languages[
                            customerLanguage.name
                        ].content
                    } `}
                    {`${totalFidelity} ${t("points")}`}
                </span>
            </div>
            <hr className="separation-line" />
        </>
    );
}
SummaryHeader.propTypes = {
    summaryHeaderBravoText: PropTypes.object,
    summaryHeaderLoyaltyPointText: PropTypes.object,
};
